import {
    Breakpoints,
    styled,
    Text,
    TextTag,
    TokenTextAppearance,
} from '@volkswagen-onehub/components-core'
import React from 'react'
import type {DefaultTheme} from 'styled-components'

const StyledSubtitle = styled(Text)`
    font-size: 14px;
    color: ${({theme}: {theme: DefaultTheme}) => theme.colors.content.active};
    margin: 0;

    @media (min-width: ${Breakpoints.b560}px) {
        font-size: 16px;
    }
`

interface BannerSubTitleProperties {
    label: string
}

export default function BannerSubTitle(
    props: BannerSubTitleProperties
): React.JSX.Element {
    return (
        <StyledSubtitle
            bold
            tag={TextTag.p}
            appearance={TokenTextAppearance.copy200}
        >
            {props.label}
        </StyledSubtitle>
    )
}
